<div class="modal-header">
  <h4 class="modal-title">
    {{ pageTitle }}
  </h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group m-0 p-0">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="alternate_sku"
        placeholder="Alternate SKU"
        aria-label="Alternate SKU"
        aria-describedby="basic-addon2"
        (keydown.enter)="addSKU()"
      />
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" (click)="addSKU()"
          >ADD</button
        >
      </div>
    </div>
  </div>
  <div class="loading" *ngIf="loading">
    <h6 class="mb-2"
      ><i class="fas fa-spinner fa-spin"></i> Saving alternate SKU, please
      wait...</h6
    >
  </div>
  <div class="alternate-skus mt-3">
    <span
      class="kt-badge kt-badge--primary kt-badge--outline kt-badge--pill"
      *ngFor="let sku of alternateSKUs; let i = index"
    >
      {{ sku.alternate_sku }}
      <a
        href="javascript:;"
        class="m-2"
        (click)="removeAlternateSku(i)"
        title="Delete Alternate SKU"
      >
        <i class="fas fa-times text-danger"></i>
      </a>
    </span>
  </div>
</div>
